import {
  getAuth,
  onIdTokenChanged as _onIdTokenChanged,
  onAuthStateChanged as _onAuthStateChanged,
} from 'firebase/auth';

import { firebaseApp } from '../';

// ----------------------------------------------------------------------

export const AUTH = getAuth(firebaseApp);

export function onAuthStateChanged(callback) {
  return _onAuthStateChanged(AUTH, callback);
}

export function onIdTokenChanged(callback) {
  return _onIdTokenChanged(AUTH, callback);
}
